import { AddPayee, GetPayee, GetUserAgentDispense, SaveUserAgentDispense, GetBalance, InitUserPWD, BatchDispense, GetDispenseDetailed, GetDispenseRefund, GetDispenseRefundMoney, GetDispenseTotal, GetAngleDispenseDetailed, LogoutAccount } from '@/api/payment'
export default {
  state: {

  },
  actions: {
    AddPayee({ commit }, payload) {
      return new Promise(resolve => {
        AddPayee(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetPayee({ commit }, payload) {
      return new Promise(resolve => {
        GetPayee(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetUserAgentDispense({ commit }, payload) {
      return new Promise(resolve => {
        GetUserAgentDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveUserAgentDispense({ commit }, payload) {
      return new Promise(resolve => {
        SaveUserAgentDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetBalance({ commit }, payload) {
      return new Promise(resolve => {
        GetBalance(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    InitUserPWD({ commit }, payload) {
      return new Promise(resolve => {
        InitUserPWD(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    BatchDispense({ commit }, payload) {
      return new Promise(resolve => {
        BatchDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDispenseDetailed({ commit }, payload) {
      return new Promise(resolve => {
        GetDispenseDetailed(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDispenseRefund({ commit }, payload) {
      return new Promise(resolve => {
        GetDispenseRefund(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDispenseRefundMoney({ commit }, payload) {
      return new Promise(resolve => {
        GetDispenseRefundMoney(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetDispenseTotal({ commit }, payload) {
      return new Promise(resolve => {
        GetDispenseTotal(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetAngleDispenseDetailed({ commit }, payload) {
      return new Promise(resolve => {
        GetAngleDispenseDetailed(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    LogoutAccount({ commit }, payload) {
      return new Promise(resolve => {
        LogoutAccount(payload).then(res => {
          resolve(res.data)
        })
      })
    },

  },
  getters: {

  },
  mutations: {

  }
}
